import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { SkipToContent } from 'src/modules/ScreenReader/SkipToContent';

import translations from './.vocab';
import { Footer } from './Footer';
import { Header } from './Header';

const Layout = ({ children }: { children?: ReactNode }) => {
  const { t } = useTranslations(translations);

  return (
    <>
      <SkipToContent>{t('Skip to content')}</SkipToContent>
      <Box style={{ minHeight: '100vh' }} paddingBottom="xxxlarge">
        <Header />
        {children ? children : <Outlet />}
      </Box>
      <Footer lean />
    </>
  );
};

export default Layout;
